import type { WriteScopes } from './useWriteScopes';

/** How an admin side panel opens a row: create, edit, prefilled copy, or read-only. */
export type PolicyFormMode = 'add' | 'edit' | 'duplicate' | 'view';

/** Modes for opening an existing row (everything but creating a new one). */
export type PolicyRowMode = Exclude<PolicyFormMode, 'add'>;

/** Whether saving in `mode` is allowed: edit needs PUT, add and duplicate need POST. */
export const canSaveInMode = (
  mode: PolicyFormMode,
  { canCreate, canEdit }: Pick<WriteScopes, 'canCreate' | 'canEdit'>,
): boolean => {
  if (mode === 'view') {
    return false;
  }
  return mode === 'edit' ? canEdit : canCreate;
};
